export default class ShowInfo {
    constructor(triggers) {
        this.btns = document.querySelectorAll(triggers);
    }

    init() {
        this.btns.forEach(btn => {
            btn.addEventListener('click', () => {
                /* btn.closest('.module__info-show').nextElementSibling.style.display = 'block'; */
                
                const sibling = btn.closest('.module__info-show').nextElementSibling;

                sibling.classList.toggle("msg");
                sibling.style.marginTop = '20px';
                sibling.style.fontSize = '14px';
                sibling.style.lineHeight = '16px';
            });
        });
    }
}